// Active Onyx Fit - Premium Boxing, MMA & Combat Sports Gear
// Real product images sourced from activeonyx.com

// ============================================
// SITE IMAGES - Combat Sports Theme
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1575654402720-0af3480d1fad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
  heroSecondary: 'https://images.unsplash.com/photo-1570170609489-43197f518df0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
  heroLifestyle: 'https://images.unsplash.com/photo-1526792903869-f3035bfc7f29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
  ctaBackground: 'https://images.unsplash.com/photo-1570170609489-43197f518df0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
  featuredBackground: 'https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHx0cmFpbmluZ3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3Nzc5MTAwMjh8MA&ixlib=rb-4.1.0&q=85&w=1920',
  powerBackground: 'https://images.unsplash.com/photo-1526793248754-cf6014a378e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxib3hpbmclMjBnbG92ZXN8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEyMjI0fDA&ixlib=rb-4.1.0&q=85&w=1920',
  shopBanner: 'https://images.unsplash.com/photo-1526792903869-f3035bfc7f29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
  aboutBanner: 'https://images.unsplash.com/photo-1570170609489-43197f518df0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
  contactBanner: 'https://images.unsplash.com/photo-1528805639423-44f7d2a3b368?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHx0cmFpbmluZ3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3Nzc5MTAwMjh8MA&ixlib=rb-4.1.0&q=85&w=1920',
  returnsBanner: 'https://images.unsplash.com/photo-1570456824246-bd6d13126fc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxib3hlciUyMHB1bmNoaW5nfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc3NzkxMjIxN3ww&ixlib=rb-4.1.0&q=85&w=1920',
  privacyBanner: 'https://images.unsplash.com/photo-1575654402720-0af3480d1fad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxib3hpbmd8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc3OTEwMDExfDA&ixlib=rb-4.1.0&q=85&w=1920',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 75;

export const CARD_DESCRIPTOR = 'ACTIVE ONYX FIT';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(888) 694-1953',
  email: 'contactus@activeonyxfit.com',
  corpName: 'Arah Capital Group LLC',
  address: {
    street: '1331 W HADDINGTON CT',
    city: 'PALATINE',
    state: 'IL',
    zip: '60067-6616',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '555 Remington Blvd., Ste B',
  city: 'Bolingbrook',
  state: 'IL',
  zip: '60440',
  country: 'USA'
};

// AUTO-GENERATED FROM ACTIVEONYX.COM PRODUCT API

export const products = [
  {
    id: "youngstar-youth-mma-gloves",
    name: "Youngstar Youth MMA Gloves",
    slug: "youngstar-youth-mma-gloves",
    sku: "AO-YOUNGS",
    price: 34.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box101.jpg",
    badge: "Youth",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "youngstar-youth-mma-training-gloves",
    name: "Youngstar Youth MMA Training Gloves",
    slug: "youngstar-youth-mma-training-gloves",
    sku: "AO-YOUNGS",
    price: 39.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box98.jpg",
    badge: "Youth",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "pro-fight-2-0-boxing-gloves-red",
    name: "Pro Fight 2.0 Boxing Gloves Red",
    slug: "pro-fight-2-0-boxing-gloves-red",
    sku: "AO-PRO-FI",
    price: 99.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box95.jpg",
    badge: "Pro Series",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "pinnacle-boxing-gloves",
    name: "Pinnacle Boxing Gloves",
    slug: "pinnacle-boxing-gloves",
    sku: "AO-PINNAC",
    price: 129.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box94.jpg",
    badge: "Pro Series",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "mft-air-training-gloves",
    name: "MFT Air Training Gloves",
    slug: "mft-air-training-gloves",
    sku: "AO-MFT-AI",
    price: 89.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box91.jpg",
    badge: "Essential",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "s-class-boxing-gloves-red",
    name: "S-Class Boxing Gloves Red",
    slug: "s-class-boxing-gloves-red",
    sku: "AO-S-CLAS",
    price: 74.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box90.jpg",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "s-class-boxing-gloves-blue",
    name: "S-Class Boxing Gloves Blue",
    slug: "s-class-boxing-gloves-blue",
    sku: "AO-S-CLAS",
    price: 74.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box85.jpg",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "c2-turbo-boxing-gloves-black-red",
    name: "C2 Turbo Boxing Gloves Black/Red",
    slug: "c2-turbo-boxing-gloves-black-red",
    sku: "AO-C2-TUR",
    price: 54.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box76.jpg",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "c2-turbo-boxing-gloves-yellow-black",
    name: "C2 Turbo Boxing Gloves Yellow/Black",
    slug: "c2-turbo-boxing-gloves-yellow-black",
    sku: "AO-C2-TUR",
    price: 54.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box67.jpg",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "supreme-thai-boxing-gloves-black",
    name: "Supreme Thai Boxing Gloves Black",
    slug: "supreme-thai-boxing-gloves-black",
    sku: "AO-SUPREM",
    price: 84.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box62.jpg",
    categoryId: "boxing-gloves",
    categorySlug: "boxing-gloves",
    description: "Pro-tested boxing gloves with multi-layer impact foam, locked-in wrist support and a premium finish that holds up round after round of training and sparring.",
    keyBenefits: ["Multi-layer impact foam for safer sparring", "Locked-in wrist support for clean punches", "Premium build that lasts daily training"],
    usage: "Ideal for heavy bag work, mitt rounds and controlled sparring. Wrap your hands, slide in and Velcro the strap snugly across the wrist.",
    features: ["Multi-Layer Foam", "Velcro Wrist Strap", "Premium Build", "Pro Sparring Ready"],
    inStock: true
  },
  {
    id: "super-pro-mma-fight-gloves",
    name: "Super Pro MMA Fight Gloves",
    slug: "super-pro-mma-fight-gloves",
    sku: "AO-SUPER-",
    price: 54.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mma22.jpg",
    categoryId: "mma-gloves",
    categorySlug: "mma-gloves",
    description: "Open-finger MMA gloves engineered for grappling and striking. Soft padding, sticky palm grip and reinforced wrist support make these a solid daily training glove.",
    keyBenefits: ["Open-finger design for clean grappling", "Padded knuckle area for striking drills", "Reinforced wrist for stability"],
    usage: "Great for full MMA training: bag work, pad work, sparring drills and grappling rounds.",
    features: ["Open Finger", "Padded Knuckles", "Sticky Palm Grip", "Reinforced Wrist"],
    inStock: true
  },
  {
    id: "fight-safe-amateur-fight-glove",
    name: "Fight Safe Amateur Fight Glove",
    slug: "fight-safe-amateur-fight-glove",
    sku: "AO-FIGHT-",
    price: 54.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mma19.jpg",
    categoryId: "mma-gloves",
    categorySlug: "mma-gloves",
    description: "Open-finger MMA gloves engineered for grappling and striking. Soft padding, sticky palm grip and reinforced wrist support make these a solid daily training glove.",
    keyBenefits: ["Open-finger design for clean grappling", "Padded knuckle area for striking drills", "Reinforced wrist for stability"],
    usage: "Great for full MMA training: bag work, pad work, sparring drills and grappling rounds.",
    features: ["Open Finger", "Padded Knuckles", "Sticky Palm Grip", "Reinforced Wrist"],
    inStock: true
  },
  {
    id: "youngstar-youth-mma-gloves-2",
    name: "Youngstar Youth MMA Gloves",
    slug: "youngstar-youth-mma-gloves-2",
    sku: "AO-YOUNGS",
    price: 34.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box112.jpg",
    badge: "Youth",
    categoryId: "mma-gloves",
    categorySlug: "mma-gloves",
    description: "Open-finger MMA gloves engineered for grappling and striking. Soft padding, sticky palm grip and reinforced wrist support make these a solid daily training glove.",
    keyBenefits: ["Open-finger design for clean grappling", "Padded knuckle area for striking drills", "Reinforced wrist for stability"],
    usage: "Great for full MMA training: bag work, pad work, sparring drills and grappling rounds.",
    features: ["Open Finger", "Padded Knuckles", "Sticky Palm Grip", "Reinforced Wrist"],
    inStock: true
  },
  {
    id: "mma-tech-4oz-professional-fight-gloves",
    name: "MMA Tech 4oz. Professional Fight Gloves",
    slug: "mma-tech-4oz-professional-fight-gloves",
    sku: "AO-MMA-TE",
    price: 59.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box109.jpg",
    categoryId: "mma-gloves",
    categorySlug: "mma-gloves",
    description: "Open-finger MMA gloves engineered for grappling and striking. Soft padding, sticky palm grip and reinforced wrist support make these a solid daily training glove.",
    keyBenefits: ["Open-finger design for clean grappling", "Padded knuckle area for striking drills", "Reinforced wrist for stability"],
    usage: "Great for full MMA training: bag work, pad work, sparring drills and grappling rounds.",
    features: ["Open Finger", "Padded Knuckles", "Sticky Palm Grip", "Reinforced Wrist"],
    inStock: true
  },
  {
    id: "bjj-life-jiu-jitsu-lifestyle-t-shirt",
    name: "BJJ Life Jiu Jitsu Lifestyle T-Shirt",
    slug: "bjj-life-jiu-jitsu-lifestyle-t-shirt",
    sku: "AO-BJJ-LI",
    price: 26.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb24.jpg",
    categoryId: "t-shirts",
    categorySlug: "t-shirts",
    description: "Combat-sports lifestyle tee with bold front graphic, soft cotton build and a fit that wears well in the gym, on the road or off the mats.",
    keyBenefits: ["Soft, breathable cotton blend", "Bold combat-sports graphic", "Versatile fit for training and lifestyle"],
    usage: "Wear to training, after rolling, or as everyday gear. Cold wash, hang to dry to keep the print sharp.",
    features: ["Soft Cotton", "Bold Graphic", "Daily Wear", "Combat Lifestyle"],
    inStock: true
  },
  {
    id: "crnr-reverse-t-shirt-od-green",
    name: "CRNR Reverse T-Shirt OD Green",
    slug: "crnr-reverse-t-shirt-od-green",
    sku: "AO-CRNR-R",
    price: 26.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb22.jpg",
    categoryId: "t-shirts",
    categorySlug: "t-shirts",
    description: "Combat-sports lifestyle tee with bold front graphic, soft cotton build and a fit that wears well in the gym, on the road or off the mats.",
    keyBenefits: ["Soft, breathable cotton blend", "Bold combat-sports graphic", "Versatile fit for training and lifestyle"],
    usage: "Wear to training, after rolling, or as everyday gear. Cold wash, hang to dry to keep the print sharp.",
    features: ["Soft Cotton", "Bold Graphic", "Daily Wear", "Combat Lifestyle"],
    inStock: true
  },
  {
    id: "crnr-reverse-t-shirt-black",
    name: "CRNR Reverse T-Shirt Black",
    slug: "crnr-reverse-t-shirt-black",
    sku: "AO-CRNR-R",
    price: 26.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb20.jpg",
    categoryId: "t-shirts",
    categorySlug: "t-shirts",
    description: "Combat-sports lifestyle tee with bold front graphic, soft cotton build and a fit that wears well in the gym, on the road or off the mats.",
    keyBenefits: ["Soft, breathable cotton blend", "Bold combat-sports graphic", "Versatile fit for training and lifestyle"],
    usage: "Wear to training, after rolling, or as everyday gear. Cold wash, hang to dry to keep the print sharp.",
    features: ["Soft Cotton", "Bold Graphic", "Daily Wear", "Combat Lifestyle"],
    inStock: true
  },
  {
    id: "muay-thai-worldwide-t-shirt",
    name: "Muay Thai Worldwide T-Shirt",
    slug: "muay-thai-worldwide-t-shirt",
    sku: "AO-MUAY-T",
    price: 26.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb16.jpg",
    categoryId: "t-shirts",
    categorySlug: "t-shirts",
    description: "Combat-sports lifestyle tee with bold front graphic, soft cotton build and a fit that wears well in the gym, on the road or off the mats.",
    keyBenefits: ["Soft, breathable cotton blend", "Bold combat-sports graphic", "Versatile fit for training and lifestyle"],
    usage: "Wear to training, after rolling, or as everyday gear. Cold wash, hang to dry to keep the print sharp.",
    features: ["Soft Cotton", "Bold Graphic", "Daily Wear", "Combat Lifestyle"],
    inStock: true
  },
  {
    id: "big-crnr-reverse-t-shirt",
    name: "Big CRNR Reverse T-Shirt",
    slug: "big-crnr-reverse-t-shirt",
    sku: "AO-BIG-CR",
    price: 26.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb14.jpg",
    categoryId: "t-shirts",
    categorySlug: "t-shirts",
    description: "Combat-sports lifestyle tee with bold front graphic, soft cotton build and a fit that wears well in the gym, on the road or off the mats.",
    keyBenefits: ["Soft, breathable cotton blend", "Bold combat-sports graphic", "Versatile fit for training and lifestyle"],
    usage: "Wear to training, after rolling, or as everyday gear. Cold wash, hang to dry to keep the print sharp.",
    features: ["Soft Cotton", "Bold Graphic", "Daily Wear", "Combat Lifestyle"],
    inStock: true
  },
  {
    id: "bdk-aint-no-half-steppin-t-shirt",
    name: "BDK Aint No Half Steppin T-Shirt",
    slug: "bdk-aint-no-half-steppin-t-shirt",
    sku: "AO-BDK-AI",
    price: 26.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb12.jpg",
    categoryId: "t-shirts",
    categorySlug: "t-shirts",
    description: "Combat-sports lifestyle tee with bold front graphic, soft cotton build and a fit that wears well in the gym, on the road or off the mats.",
    keyBenefits: ["Soft, breathable cotton blend", "Bold combat-sports graphic", "Versatile fit for training and lifestyle"],
    usage: "Wear to training, after rolling, or as everyday gear. Cold wash, hang to dry to keep the print sharp.",
    features: ["Soft Cotton", "Bold Graphic", "Daily Wear", "Combat Lifestyle"],
    inStock: true
  },
  {
    id: "hmit-model-2-retro-muay-thai-shorts-pink",
    name: "HMIT Model 2 Retro Muay Thai Shorts Pink",
    slug: "hmit-model-2-retro-muay-thai-shorts-pink",
    sku: "AO-HMIT-M",
    price: 59.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/fs76.jpg",
    categoryId: "fight-shorts",
    categorySlug: "fight-shorts",
    description: "Pro-level fight shorts engineered for full range of motion. Reinforced seams, four-way stretch panels and a secure waistband keep things locked in during sparring and competition.",
    keyBenefits: ["Four-way stretch panels for full mobility", "Reinforced seams that survive grappling", "Secure non-slip waistband"],
    usage: "Built for MMA, kickboxing, Muay Thai and grappling rounds. Hand wash in cold water for best longevity.",
    features: ["Four-Way Stretch", "Reinforced Seams", "Secure Waistband", "Competition Ready"],
    inStock: true
  },
  {
    id: "hmit-model-2-retro-muay-thai-shorts-yellow",
    name: "HMIT Model 2 Retro Muay Thai Shorts Yellow",
    slug: "hmit-model-2-retro-muay-thai-shorts-yellow",
    sku: "AO-HMIT-M",
    price: 59.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/fs71.jpg",
    categoryId: "fight-shorts",
    categorySlug: "fight-shorts",
    description: "Pro-level fight shorts engineered for full range of motion. Reinforced seams, four-way stretch panels and a secure waistband keep things locked in during sparring and competition.",
    keyBenefits: ["Four-way stretch panels for full mobility", "Reinforced seams that survive grappling", "Secure non-slip waistband"],
    usage: "Built for MMA, kickboxing, Muay Thai and grappling rounds. Hand wash in cold water for best longevity.",
    features: ["Four-Way Stretch", "Reinforced Seams", "Secure Waistband", "Competition Ready"],
    inStock: true
  },
  {
    id: "hmit-model-2-retro-muay-thai-shorts-blue",
    name: "HMIT Model 2 Retro Muay Thai Shorts Blue",
    slug: "hmit-model-2-retro-muay-thai-shorts-blue",
    sku: "AO-HMIT-M",
    price: 59.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/fs66.jpg",
    categoryId: "fight-shorts",
    categorySlug: "fight-shorts",
    description: "Pro-level fight shorts engineered for full range of motion. Reinforced seams, four-way stretch panels and a secure waistband keep things locked in during sparring and competition.",
    keyBenefits: ["Four-way stretch panels for full mobility", "Reinforced seams that survive grappling", "Secure non-slip waistband"],
    usage: "Built for MMA, kickboxing, Muay Thai and grappling rounds. Hand wash in cold water for best longevity.",
    features: ["Four-Way Stretch", "Reinforced Seams", "Secure Waistband", "Competition Ready"],
    inStock: true
  },
  {
    id: "collab-fight-shorts",
    name: "Collab Fight Shorts",
    slug: "collab-fight-shorts",
    sku: "AO-COLLAB",
    price: 59.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/fs61.jpg",
    categoryId: "fight-shorts",
    categorySlug: "fight-shorts",
    description: "Pro-level fight shorts engineered for full range of motion. Reinforced seams, four-way stretch panels and a secure waistband keep things locked in during sparring and competition.",
    keyBenefits: ["Four-way stretch panels for full mobility", "Reinforced seams that survive grappling", "Secure non-slip waistband"],
    usage: "Built for MMA, kickboxing, Muay Thai and grappling rounds. Hand wash in cold water for best longevity.",
    features: ["Four-Way Stretch", "Reinforced Seams", "Secure Waistband", "Competition Ready"],
    inStock: true
  },
  {
    id: "youth-muay-thai-shorts",
    name: "Youth Muay Thai Shorts",
    slug: "youth-muay-thai-shorts",
    sku: "AO-YOUTH-",
    price: 44.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/fs56.jpg",
    badge: "Youth",
    categoryId: "fight-shorts",
    categorySlug: "fight-shorts",
    description: "Pro-level fight shorts engineered for full range of motion. Reinforced seams, four-way stretch panels and a secure waistband keep things locked in during sparring and competition.",
    keyBenefits: ["Four-way stretch panels for full mobility", "Reinforced seams that survive grappling", "Secure non-slip waistband"],
    usage: "Built for MMA, kickboxing, Muay Thai and grappling rounds. Hand wash in cold water for best longevity.",
    features: ["Four-Way Stretch", "Reinforced Seams", "Secure Waistband", "Competition Ready"],
    inStock: true
  },
  {
    id: "c2-curved-punch-mitts-w-xtrafresh",
    name: "C2 Curved Punch Mitts w/ XtraFresh",
    slug: "c2-curved-punch-mitts-w-xtrafresh",
    sku: "AO-C2-CUR",
    price: 44.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/pm25.jpg",
    categoryId: "punch-mitts",
    categorySlug: "punch-mitts",
    description: "Pro coaching punch mitts with sculpted padding, curved palm shape and a snug strap to keep them locked in through long pad rounds.",
    keyBenefits: ["Sculpted padding for safe coach hands", "Curved palm for natural target shape", "Snug strap that stays in place"],
    usage: "Coach combos with confidence. Pair with hand wraps and quality boxing gloves.",
    features: ["Sculpted Padding", "Curved Palm", "Snug Strap", "Pro Coaching"],
    inStock: true
  },
  {
    id: "hmit-punch-mitts",
    name: "HMIT Punch Mitts",
    slug: "hmit-punch-mitts",
    sku: "AO-HMIT-P",
    price: 129.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/pm22.jpg",
    badge: "Premium",
    categoryId: "punch-mitts",
    categorySlug: "punch-mitts",
    description: "Pro coaching punch mitts with sculpted padding, curved palm shape and a snug strap to keep them locked in through long pad rounds.",
    keyBenefits: ["Sculpted padding for safe coach hands", "Curved palm for natural target shape", "Snug strap that stays in place"],
    usage: "Coach combos with confidence. Pair with hand wraps and quality boxing gloves.",
    features: ["Sculpted Padding", "Curved Palm", "Snug Strap", "Pro Coaching"],
    inStock: true
  },
  {
    id: "hmit-mini-mitts",
    name: "HMIT Mini Mitts",
    slug: "hmit-mini-mitts",
    sku: "AO-HMIT-M",
    price: 119.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/pm19.jpg",
    badge: "Premium",
    categoryId: "punch-mitts",
    categorySlug: "punch-mitts",
    description: "Pro coaching punch mitts with sculpted padding, curved palm shape and a snug strap to keep them locked in through long pad rounds.",
    keyBenefits: ["Sculpted padding for safe coach hands", "Curved palm for natural target shape", "Snug strap that stays in place"],
    usage: "Coach combos with confidence. Pair with hand wraps and quality boxing gloves.",
    features: ["Sculpted Padding", "Curved Palm", "Snug Strap", "Pro Coaching"],
    inStock: true
  },
  {
    id: "hmit-tech-punch-mitts-green",
    name: "HMIT Tech Punch Mitts Green",
    slug: "hmit-tech-punch-mitts-green",
    sku: "AO-HMIT-T",
    price: 139.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/pm16.jpg",
    badge: "Premium",
    categoryId: "punch-mitts",
    categorySlug: "punch-mitts",
    description: "Pro coaching punch mitts with sculpted padding, curved palm shape and a snug strap to keep them locked in through long pad rounds.",
    keyBenefits: ["Sculpted padding for safe coach hands", "Curved palm for natural target shape", "Snug strap that stays in place"],
    usage: "Coach combos with confidence. Pair with hand wraps and quality boxing gloves.",
    features: ["Sculpted Padding", "Curved Palm", "Snug Strap", "Pro Coaching"],
    inStock: true
  },
  {
    id: "hmit-thai-pads",
    name: "HMIT Thai Pads",
    slug: "hmit-thai-pads",
    sku: "AO-HMIT-T",
    price: 139.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mtp26.jpg",
    badge: "Premium",
    categoryId: "thai-pads",
    categorySlug: "thai-pads",
    description: "Thai pads with layered foam, double-strap forearm hold and a curved face built for kicks, knees and combos at high volume.",
    keyBenefits: ["Layered foam absorbs heavy impact", "Double-strap forearm hold", "Curved face shaped for kicks"],
    usage: "Hold for round-after-round Muay Thai pad work. Great for kicks, knees, elbows and punch combos.",
    features: ["Layered Foam", "Double-Strap Hold", "Curved Face", "Muay Thai Build"],
    inStock: true
  },
  {
    id: "hmit-power-punch-cushion",
    name: "HMIT Power Punch Cushion",
    slug: "hmit-power-punch-cushion",
    sku: "AO-HMIT-P",
    price: 169.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mtp22.jpg",
    badge: "Premium",
    categoryId: "thai-pads",
    categorySlug: "thai-pads",
    description: "Thai pads with layered foam, double-strap forearm hold and a curved face built for kicks, knees and combos at high volume.",
    keyBenefits: ["Layered foam absorbs heavy impact", "Double-strap forearm hold", "Curved face shaped for kicks"],
    usage: "Hold for round-after-round Muay Thai pad work. Great for kicks, knees, elbows and punch combos.",
    features: ["Layered Foam", "Double-Strap Hold", "Curved Face", "Muay Thai Build"],
    inStock: true
  },
  {
    id: "8-muay-thai-single-strap-thai-pad-navy-blue",
    name: "8 Muay Thai Single Strap Thai Pad Navy Blue",
    slug: "8-muay-thai-single-strap-thai-pad-navy-blue",
    sku: "AO-8-MUAY",
    price: 169.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mtp18.jpg",
    badge: "Premium",
    categoryId: "thai-pads",
    categorySlug: "thai-pads",
    description: "Thai pads with layered foam, double-strap forearm hold and a curved face built for kicks, knees and combos at high volume.",
    keyBenefits: ["Layered foam absorbs heavy impact", "Double-strap forearm hold", "Curved face shaped for kicks"],
    usage: "Hold for round-after-round Muay Thai pad work. Great for kicks, knees, elbows and punch combos.",
    features: ["Layered Foam", "Double-Strap Hold", "Curved Face", "Muay Thai Build"],
    inStock: true
  },
  {
    id: "throw-and-gp-dummy",
    name: "Throw and G&P Dummy",
    slug: "throw-and-gp-dummy",
    sku: "AO-THROW-",
    price: 119.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb8.jpg",
    badge: "Premium",
    categoryId: "striking-bags",
    categorySlug: "striking-bags",
    description: "Heavy-duty striking bag built to take a beating. Reinforced shell, dense fill and rugged hanging system handle the highest training intensity.",
    keyBenefits: ["Reinforced striking shell", "Dense fill for satisfying impact", "Heavy-duty hanging system"],
    usage: "Hang in your gym setup. Use for boxing, kickboxing and Muay Thai training rounds.",
    features: ["Reinforced Shell", "Dense Fill", "Heavy-Duty Hang", "Pro Training Bag"],
    inStock: true
  },
  {
    id: "filled-42%e2%80%b3x16%e2%80%b3-striketuff-heavy-bag-new-size",
    name: "FILLED- 42\u2033x16\u2033 StrikeTuff Heavy Bag (NEW size)",
    slug: "filled-42%e2%80%b3x16%e2%80%b3-striketuff-heavy-bag-new-size",
    sku: "AO-FILLED",
    price: 199.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb7.jpg",
    badge: "Premium",
    categoryId: "striking-bags",
    categorySlug: "striking-bags",
    description: "Heavy-duty striking bag built to take a beating. Reinforced shell, dense fill and rugged hanging system handle the highest training intensity.",
    keyBenefits: ["Reinforced striking shell", "Dense fill for satisfying impact", "Heavy-duty hanging system"],
    usage: "Hang in your gym setup. Use for boxing, kickboxing and Muay Thai training rounds.",
    features: ["Reinforced Shell", "Dense Fill", "Heavy-Duty Hang", "Pro Training Bag"],
    inStock: true
  },
  {
    id: "hmit-half-nylon-leather-heavy-bag-unfilled",
    name: "HMIT Half Nylon & Leather Heavy Bag (Unfilled)",
    slug: "hmit-half-nylon-leather-heavy-bag-unfilled",
    sku: "AO-HMIT-H",
    price: 324.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb6.jpg",
    badge: "Premium",
    categoryId: "striking-bags",
    categorySlug: "striking-bags",
    description: "Heavy-duty striking bag built to take a beating. Reinforced shell, dense fill and rugged hanging system handle the highest training intensity.",
    keyBenefits: ["Reinforced striking shell", "Dense fill for satisfying impact", "Heavy-duty hanging system"],
    usage: "Hang in your gym setup. Use for boxing, kickboxing and Muay Thai training rounds.",
    features: ["Reinforced Shell", "Dense Fill", "Heavy-Duty Hang", "Pro Training Bag"],
    inStock: true
  },
  {
    id: "8-muay-thai-belly-pad-red",
    name: "8 Muay Thai Belly Pad Red",
    slug: "8-muay-thai-belly-pad-red",
    sku: "AO-8-MUAY",
    price: 139.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bp13.jpg",
    badge: "Premium",
    categoryId: "body-protectors",
    categorySlug: "body-protectors",
    description: "Coach-grade belly pad with shock-absorbing foam, contoured shape and double straps so you can take heavy body shots round after round.",
    keyBenefits: ["Shock-absorbing layered foam", "Contoured belly shape for clean fit", "Double strap secure hold"],
    usage: "Coach belly-shot drills and body work. Adjust strap to your torso for a snug, no-slip fit.",
    features: ["Layered Foam", "Contoured Fit", "Double Strap", "Coach Grade"],
    inStock: true
  },
  {
    id: "8-muay-thai-belly-pad-yellow",
    name: "8 Muay Thai Belly Pad Yellow",
    slug: "8-muay-thai-belly-pad-yellow",
    sku: "AO-8-MUAY",
    price: 139.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bp14.jpg",
    badge: "Premium",
    categoryId: "body-protectors",
    categorySlug: "body-protectors",
    description: "Coach-grade belly pad with shock-absorbing foam, contoured shape and double straps so you can take heavy body shots round after round.",
    keyBenefits: ["Shock-absorbing layered foam", "Contoured belly shape for clean fit", "Double strap secure hold"],
    usage: "Coach belly-shot drills and body work. Adjust strap to your torso for a snug, no-slip fit.",
    features: ["Layered Foam", "Contoured Fit", "Double Strap", "Coach Grade"],
    inStock: true
  },
  {
    id: "bjj-belt-green-black",
    name: "BJJ Belt Green/Black",
    slug: "bjj-belt-green-black",
    sku: "AO-BJJ-BE",
    price: 14.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj91.jpg",
    badge: "Essential",
    categoryId: "bjj-belts",
    categorySlug: "bjj-belts",
    description: "Premium BJJ belt with structured cotton weave, reinforced stitching and a length built to hold a clean knot after years of rolling.",
    keyBenefits: ["Structured cotton weave", "Reinforced bar stitching", "Length true to BJJ standards"],
    usage: "Wear with your gi for training, open mat and competition. Cold wash, hang to dry.",
    features: ["Cotton Weave", "Reinforced Stitching", "Standard Length", "Comp Ready"],
    inStock: true
  },
  {
    id: "bjj-belt-green",
    name: "BJJ Belt Green",
    slug: "bjj-belt-green",
    sku: "AO-BJJ-BE",
    price: 14.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj90.jpg",
    badge: "Essential",
    categoryId: "bjj-belts",
    categorySlug: "bjj-belts",
    description: "Premium BJJ belt with structured cotton weave, reinforced stitching and a length built to hold a clean knot after years of rolling.",
    keyBenefits: ["Structured cotton weave", "Reinforced bar stitching", "Length true to BJJ standards"],
    usage: "Wear with your gi for training, open mat and competition. Cold wash, hang to dry.",
    features: ["Cotton Weave", "Reinforced Stitching", "Standard Length", "Comp Ready"],
    inStock: true
  },
  {
    id: "bjj-belt-green-white",
    name: "BJJ Belt Green/White",
    slug: "bjj-belt-green-white",
    sku: "AO-BJJ-BE",
    price: 14.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj89.jpg",
    badge: "Essential",
    categoryId: "bjj-belts",
    categorySlug: "bjj-belts",
    description: "Premium BJJ belt with structured cotton weave, reinforced stitching and a length built to hold a clean knot after years of rolling.",
    keyBenefits: ["Structured cotton weave", "Reinforced bar stitching", "Length true to BJJ standards"],
    usage: "Wear with your gi for training, open mat and competition. Cold wash, hang to dry.",
    features: ["Cotton Weave", "Reinforced Stitching", "Standard Length", "Comp Ready"],
    inStock: true
  },
  {
    id: "classic-kimono-white-w-free-white-belt",
    name: "Classic Kimono \u2013 White W/ FREE WHITE BELT!",
    slug: "classic-kimono-white-w-free-white-belt",
    sku: "AO-CLASSI",
    price: 94.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj58.jpg",
    categoryId: "bjj-gis",
    categorySlug: "bjj-gis",
    description: "Tournament-ready BJJ gi with pearl-weave jacket, ripstop pants and reinforced stress points so it survives years of rolling.",
    keyBenefits: ["Pearl-weave jacket built for grip and breathability", "Ripstop pants resist tearing", "Reinforced stress points"],
    usage: "Wear for daily training, open mat and competition. Cold wash inside out, hang to dry.",
    features: ["Pearl-Weave Jacket", "Ripstop Pants", "Reinforced Stress Points", "IBJJF Ready"],
    inStock: true
  },
  {
    id: "youngstar-youth-brazilian-jiu-jitsu-form2-gi-black-free-white-belt",
    name: "YoungStar Youth Brazilian Jiu Jitsu Form2 GI (Black) \u2013 FREE WHITE BELT",
    slug: "youngstar-youth-brazilian-jiu-jitsu-form2-gi-black-free-white-belt",
    sku: "AO-YOUNGS",
    price: 89.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj50.jpg",
    badge: "Youth",
    categoryId: "bjj-gis",
    categorySlug: "bjj-gis",
    description: "Tournament-ready BJJ gi with pearl-weave jacket, ripstop pants and reinforced stress points so it survives years of rolling.",
    keyBenefits: ["Pearl-weave jacket built for grip and breathability", "Ripstop pants resist tearing", "Reinforced stress points"],
    usage: "Wear for daily training, open mat and competition. Cold wash inside out, hang to dry.",
    features: ["Pearl-Weave Jacket", "Ripstop Pants", "Reinforced Stress Points", "IBJJF Ready"],
    inStock: true
  },
  {
    id: "youngstar-youth-brazilian-jiu-jitsu-form2-gi-blue-free-white-belt",
    name: "YoungStar Youth Brazilian Jiu Jitsu Form2 GI (Blue) \u2013 FREE WHITE BELT",
    slug: "youngstar-youth-brazilian-jiu-jitsu-form2-gi-blue-free-white-belt",
    sku: "AO-YOUNGS",
    price: 89.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj45.jpg",
    badge: "Youth",
    categoryId: "bjj-gis",
    categorySlug: "bjj-gis",
    description: "Tournament-ready BJJ gi with pearl-weave jacket, ripstop pants and reinforced stress points so it survives years of rolling.",
    keyBenefits: ["Pearl-weave jacket built for grip and breathability", "Ripstop pants resist tearing", "Reinforced stress points"],
    usage: "Wear for daily training, open mat and competition. Cold wash inside out, hang to dry.",
    features: ["Pearl-Weave Jacket", "Ripstop Pants", "Reinforced Stress Points", "IBJJF Ready"],
    inStock: true
  },
  {
    id: "black-eco-v4-0-series-jiu-jitsu-gi-free-white-belt",
    name: "Black ECO v4.0 Series Jiu Jitsu GI \u2013 FREE WHITE BELT",
    slug: "black-eco-v4-0-series-jiu-jitsu-gi-free-white-belt",
    sku: "AO-BLACK-",
    price: 109.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj40.jpg",
    badge: "Premium",
    categoryId: "bjj-gis",
    categorySlug: "bjj-gis",
    description: "Tournament-ready BJJ gi with pearl-weave jacket, ripstop pants and reinforced stress points so it survives years of rolling.",
    keyBenefits: ["Pearl-weave jacket built for grip and breathability", "Ripstop pants resist tearing", "Reinforced stress points"],
    usage: "Wear for daily training, open mat and competition. Cold wash inside out, hang to dry.",
    features: ["Pearl-Weave Jacket", "Ripstop Pants", "Reinforced Stress Points", "IBJJF Ready"],
    inStock: true
  },
  {
    id: "black-bjj-gi-pants",
    name: "Black BJJ GI Pants",
    slug: "black-bjj-gi-pants",
    sku: "AO-BLACK-",
    price: 44.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj97.jpg",
    categoryId: "bjj-pants",
    categorySlug: "bjj-pants",
    description: "Replacement BJJ gi pants in tough ripstop fabric with a reinforced waistband and roomy gusset so you can shoot, scramble and recover comfortably.",
    keyBenefits: ["Tough ripstop fabric", "Reinforced waistband", "Roomy gusset for full mobility"],
    usage: "Pair with your gi top for training and competition. Cold wash, hang to dry.",
    features: ["Ripstop Fabric", "Reinforced Waist", "Roomy Gusset", "Replacement Pants"],
    inStock: true
  },
  {
    id: "blue-bjj-gi-pants",
    name: "Blue BJJ GI Pants",
    slug: "blue-bjj-gi-pants",
    sku: "AO-BLUE-B",
    price: 44.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj95.jpg",
    categoryId: "bjj-pants",
    categorySlug: "bjj-pants",
    description: "Replacement BJJ gi pants in tough ripstop fabric with a reinforced waistband and roomy gusset so you can shoot, scramble and recover comfortably.",
    keyBenefits: ["Tough ripstop fabric", "Reinforced waistband", "Roomy gusset for full mobility"],
    usage: "Pair with your gi top for training and competition. Cold wash, hang to dry.",
    features: ["Ripstop Fabric", "Reinforced Waist", "Roomy Gusset", "Replacement Pants"],
    inStock: true
  },
  {
    id: "diamond-high-performance-cup",
    name: "Diamond High Performance Cup",
    slug: "diamond-high-performance-cup",
    sku: "AO-DIAMON",
    price: 29.95,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/joc6-scaled.jpg",
    categoryId: "jocks-cups",
    categorySlug: "jocks-cups",
    description: "Athletic compression and cup system that locks in protection without throwing off your stance or hampering your movement.",
    keyBenefits: ["Stay-put compression fit", "Tested protective cup", "Breathable moisture-wicking fabric"],
    usage: "Wear under shorts for sparring, competition and daily training. Hand wash, hang to dry.",
    features: ["Compression Fit", "Protective Cup", "Moisture-Wicking", "Pro Athletic Fit"],
    inStock: true
  },
  {
    id: "diamond-compression-jock-shorts-cup-system",
    name: "Diamond Compression Jock Shorts & Cup System",
    slug: "diamond-compression-jock-shorts-cup-system",
    sku: "AO-DIAMON",
    price: 89.95,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/joc5.jpg",
    categoryId: "jocks-cups",
    categorySlug: "jocks-cups",
    description: "Athletic compression and cup system that locks in protection without throwing off your stance or hampering your movement.",
    keyBenefits: ["Stay-put compression fit", "Tested protective cup", "Breathable moisture-wicking fabric"],
    usage: "Wear under shorts for sparring, competition and daily training. Hand wash, hang to dry.",
    features: ["Compression Fit", "Protective Cup", "Moisture-Wicking", "Pro Athletic Fit"],
    inStock: true
  },
  {
    id: "single-roll-gauze",
    name: "Single roll gauze",
    slug: "single-roll-gauze",
    sku: "AO-SINGLE",
    price: 0.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bp19.jpg",
    badge: "Essential",
    categoryId: "corner-supplies",
    categorySlug: "corner-supplies",
    description: "Corner-side essential built for trainers who run real fight nights. Reliable, no-fuss gear you can trust under pressure.",
    keyBenefits: ["Pro-grade corner essential", "Reliable construction", "Easy to pack into your kit"],
    usage: "Add to your corner kit for fight nights and serious training sessions.",
    features: ["Pro Grade", "Reliable", "Pack-Ready", "Corner Essential"],
    inStock: true
  },
  {
    id: "hmit-full-face-headgear",
    name: "HMIT Full Face HeadGear",
    slug: "hmit-full-face-headgear",
    sku: "AO-HMIT-F",
    price: 119.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin73.jpg",
    badge: "Premium",
    categoryId: "headgear",
    categorySlug: "headgear",
    description: "Boxing/MMA headgear with closed-cell foam, full cheek protection and an adjustable strap system that locks the gear into place.",
    keyBenefits: ["Closed-cell foam absorbs impact", "Full cheek and forehead coverage", "Adjustable strap system"],
    usage: "Wear during sparring rounds. Adjust straps for snug, no-slip fit before stepping in.",
    features: ["Closed-Cell Foam", "Cheek Coverage", "Adjustable Strap", "Sparring Build"],
    inStock: true
  },
  {
    id: "hmit-full-face-headgear-green",
    name: "HMIT Full Face HeadGear Green",
    slug: "hmit-full-face-headgear-green",
    sku: "AO-HMIT-F",
    price: 119.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin70.jpg",
    badge: "Premium",
    categoryId: "headgear",
    categorySlug: "headgear",
    description: "Boxing/MMA headgear with closed-cell foam, full cheek protection and an adjustable strap system that locks the gear into place.",
    keyBenefits: ["Closed-cell foam absorbs impact", "Full cheek and forehead coverage", "Adjustable strap system"],
    usage: "Wear during sparring rounds. Adjust straps for snug, no-slip fit before stepping in.",
    features: ["Closed-Cell Foam", "Cheek Coverage", "Adjustable Strap", "Sparring Build"],
    inStock: true
  },
  {
    id: "adult-mouth-guard-w-case",
    name: "Adult Mouth Guard w/ Case",
    slug: "adult-mouth-guard-w-case",
    sku: "AO-ADULT-",
    price: 5.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mg14.jpg",
    badge: "Essential",
    categoryId: "mouthguards",
    categorySlug: "mouthguards",
    description: "Boil-and-bite mouthguard with a snug custom fit, breath-friendly channel and protection built for full-contact training.",
    keyBenefits: ["Boil-and-bite custom fit", "Breathable airflow channel", "Multi-layer impact protection"],
    usage: "Boil briefly, bite into shape and wear during sparring or competition. Rinse and store dry.",
    features: ["Custom Fit", "Airflow Channel", "Multi-Layer Protect", "Pro Build"],
    inStock: true
  },
  {
    id: "black-white-mouth-guard-w-case",
    name: "Black & White Mouth Guard w/ Case",
    slug: "black-white-mouth-guard-w-case",
    sku: "AO-BLACK-",
    price: 8.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mg9.jpg",
    badge: "Essential",
    categoryId: "mouthguards",
    categorySlug: "mouthguards",
    description: "Boil-and-bite mouthguard with a snug custom fit, breath-friendly channel and protection built for full-contact training.",
    keyBenefits: ["Boil-and-bite custom fit", "Breathable airflow channel", "Multi-layer impact protection"],
    usage: "Boil briefly, bite into shape and wear during sparring or competition. Rinse and store dry.",
    features: ["Custom Fit", "Airflow Channel", "Multi-Layer Protect", "Pro Build"],
    inStock: true
  },
  {
    id: "c2-shin-guards",
    name: "C2 Shin Guards",
    slug: "c2-shin-guards",
    sku: "AO-C2-SHI",
    price: 39.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin58.jpg",
    categoryId: "shin-guards",
    categorySlug: "shin-guards",
    description: "Muay Thai shin guards with layered shock foam, full instep coverage and twin-strap closure that stay locked in through clinch and combos.",
    keyBenefits: ["Layered shock foam", "Full instep coverage", "Twin-strap secure closure"],
    usage: "Wear for Muay Thai pad rounds, kickboxing sparring and clinch work.",
    features: ["Shock Foam", "Instep Cover", "Twin Strap", "Muay Thai Build"],
    inStock: true
  },
  {
    id: "mma-shin-guards",
    name: "MMA Shin Guards",
    slug: "mma-shin-guards",
    sku: "AO-MMA-SH",
    price: 69.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin53.jpg",
    categoryId: "shin-guards",
    categorySlug: "shin-guards",
    description: "Muay Thai shin guards with layered shock foam, full instep coverage and twin-strap closure that stay locked in through clinch and combos.",
    keyBenefits: ["Layered shock foam", "Full instep coverage", "Twin-strap secure closure"],
    usage: "Wear for Muay Thai pad rounds, kickboxing sparring and clinch work.",
    features: ["Shock Foam", "Instep Cover", "Twin Strap", "Muay Thai Build"],
    inStock: true
  },
  {
    id: "hmit-shin-guards-black-green",
    name: "HMIT Shin Guards Black/Green",
    slug: "hmit-shin-guards-black-green",
    sku: "AO-HMIT-S",
    price: 119.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin50.jpg",
    badge: "Premium",
    categoryId: "shin-guards",
    categorySlug: "shin-guards",
    description: "Muay Thai shin guards with layered shock foam, full instep coverage and twin-strap closure that stay locked in through clinch and combos.",
    keyBenefits: ["Layered shock foam", "Full instep coverage", "Twin-strap secure closure"],
    usage: "Wear for Muay Thai pad rounds, kickboxing sparring and clinch work.",
    features: ["Shock Foam", "Instep Cover", "Twin Strap", "Muay Thai Build"],
    inStock: true
  },
  {
    id: "pro-hand-wraps",
    name: "Pro Hand Wraps",
    slug: "pro-hand-wraps",
    sku: "AO-PRO-HA",
    price: 6.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/hw19.jpg",
    badge: "Essential",
    categoryId: "hand-wraps",
    categorySlug: "hand-wraps",
    description: "Mexican-style stretch hand wraps with a snug elastic feel, secure thumb loop and Velcro closure that stays locked in.",
    keyBenefits: ["Mexican-style stretch fabric", "Secure thumb loop", "Strong Velcro closure"],
    usage: "Wrap before every glove session. Wash in a mesh laundry bag and hang to dry.",
    features: ["Stretch Fabric", "Thumb Loop", "Velcro Close", "Pro Wrap"],
    inStock: true
  },
  {
    id: "pro-hand-wraps-neon-green",
    name: "Pro Hand Wraps Neon Green",
    slug: "pro-hand-wraps-neon-green",
    sku: "AO-PRO-HA",
    price: 6.99,
    image: "https://activeonyx.com/wp-content/uploads/2023/05/hw17.jpg",
    badge: "Essential",
    categoryId: "hand-wraps",
    categorySlug: "hand-wraps",
    description: "Mexican-style stretch hand wraps with a snug elastic feel, secure thumb loop and Velcro closure that stays locked in.",
    keyBenefits: ["Mexican-style stretch fabric", "Secure thumb loop", "Strong Velcro closure"],
    usage: "Wrap before every glove session. Wash in a mesh laundry bag and hang to dry.",
    features: ["Stretch Fabric", "Thumb Loop", "Velcro Close", "Pro Wrap"],
    inStock: true
  },
];

export const categories = [
  {
    id: "boxing-gloves",
    name: "Boxing Gloves",
    slug: "boxing-gloves",
    description: "Premium boxing gloves for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/box101.jpg",
    productCount: 10
  },
  {
    id: "mma-gloves",
    name: "MMA Gloves",
    slug: "mma-gloves",
    description: "Premium mma gloves for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mma22.jpg",
    productCount: 4
  },
  {
    id: "t-shirts",
    name: "T-Shirts",
    slug: "t-shirts",
    description: "Premium t-shirts for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb24.jpg",
    productCount: 6
  },
  {
    id: "fight-shorts",
    name: "Fight Shorts",
    slug: "fight-shorts",
    description: "Premium fight shorts for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/fs76.jpg",
    productCount: 5
  },
  {
    id: "punch-mitts",
    name: "Punch Mitts",
    slug: "punch-mitts",
    description: "Premium punch mitts for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/pm25.jpg",
    productCount: 4
  },
  {
    id: "thai-pads",
    name: "Thai Pads",
    slug: "thai-pads",
    description: "Premium thai pads for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mtp26.jpg",
    productCount: 3
  },
  {
    id: "striking-bags",
    name: "Striking Bags",
    slug: "striking-bags",
    description: "Premium striking bags for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/sb8.jpg",
    productCount: 3
  },
  {
    id: "body-protectors",
    name: "Body Protectors",
    slug: "body-protectors",
    description: "Premium body protectors for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bp13.jpg",
    productCount: 2
  },
  {
    id: "bjj-belts",
    name: "BJJ Belts",
    slug: "bjj-belts",
    description: "Premium bjj belts for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj91.jpg",
    productCount: 3
  },
  {
    id: "bjj-gis",
    name: "BJJ Gis",
    slug: "bjj-gis",
    description: "Premium bjj gis for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj58.jpg",
    productCount: 4
  },
  {
    id: "bjj-pants",
    name: "BJJ Pants",
    slug: "bjj-pants",
    description: "Premium bjj pants for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bjj97.jpg",
    productCount: 2
  },
  {
    id: "jocks-cups",
    name: "Jocks & Cups",
    slug: "jocks-cups",
    description: "Premium jocks & cups for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/joc6-scaled.jpg",
    productCount: 2
  },
  {
    id: "corner-supplies",
    name: "Corner Supplies",
    slug: "corner-supplies",
    description: "Premium corner supplies for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/bp19.jpg",
    productCount: 1
  },
  {
    id: "headgear",
    name: "Headgear",
    slug: "headgear",
    description: "Premium headgear for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin73.jpg",
    productCount: 2
  },
  {
    id: "mouthguards",
    name: "Mouthguards",
    slug: "mouthguards",
    description: "Premium mouthguards for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/mg14.jpg",
    productCount: 2
  },
  {
    id: "shin-guards",
    name: "Shin Guards",
    slug: "shin-guards",
    description: "Premium shin guards for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/shin58.jpg",
    productCount: 3
  },
  {
    id: "hand-wraps",
    name: "Hand Wraps",
    slug: "hand-wraps",
    description: "Premium hand wraps for fighters and combat athletes",
    image: "https://activeonyx.com/wp-content/uploads/2023/05/hw19.jpg",
    productCount: 2
  },
];
// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Pro-Tested Gear', description: 'Built and tested by working coaches and combat athletes' },
  { id: 2, title: 'Fast USA Shipping', description: 'Free shipping on orders over $75' },
  { id: 3, title: '30-Day Returns', description: 'Easy returns on every order, no drama' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and protected customer data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Power', description: 'Punch heavier with gloves built for impact and protection' },
  { id: 2, title: 'Speed', description: 'Move faster in lighter gear engineered for hand speed' },
  { id: 3, title: 'Durability', description: 'Pro-level construction designed to survive daily training' },
  { id: 4, title: 'Style', description: 'Combat-sports apparel that wears as hard as it trains' }
];

export const steps = [
  { id: 1, title: 'Browse the Roster', description: 'Explore our hand-picked boxing, MMA and combat-sports gear.' },
  { id: 2, title: 'Pick Your Weapon', description: 'Choose the gloves, tees or apparel that fit your training.' },
  { id: 3, title: 'Secure Checkout', description: 'Lock in your order with encrypted, protected payment.' },
  { id: 4, title: 'Train Like a Pro', description: 'Open the box, glove up, and get to work.' }
];
